function useMainNavigationState() {
  const { isTabletOrMobile } = useDevice();
  // these vars need to be state as device is guessed in SSR. Therefore not useing useState will cause hydration issues
  const isMobileMode = useState("navigationIsMobileMode", () => isTabletOrMobile.value);
  const isMobileOpen = useState("navigationIsMobileOpen", () => false);
  const activeMenu = useState("navigationActiveMenu", () => null);
  const activeMenuIndex = useState("navigationActiveMenuIndex", () => null);
  const isAccordionOpen = useState("navigationIsAccordionOpen", () => false);

  const resetState = () => {
    isMobileOpen.value = false;
    activeMenu.value = null;
    activeMenuIndex.value = null;
    isAccordionOpen.value = false;
  };

  const isMenuOpen = computed(() =>
    isMobileMode.value ? isMobileOpen.value : activeMenuIndex.value !== null,
  );

  return {
    isMobileOpen,
    isMenuOpen,
    activeMenuIndex,
    isMobileMode,
    activeMenu,
    isAccordionOpen,
    resetState,
  };
}

export default useMainNavigationState;
